var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInternalStaffIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 28,
    viewBox: "0 0 48 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "groups_FILL0_wght400_GRAD0_opsz48",
    d: "M0,36V33.35A3.569,3.569,0,0,1,2.1,30.2,10.8,10.8,0,0,1,7.5,29q.65,0,1.2.025a8.232,8.232,0,0,1,1.1.125,8.141,8.141,0,0,0-.8,3.6V36Zm12,0V32.75q0-3.25,3.325-5.25A16.67,16.67,0,0,1,24,25.5a16.643,16.643,0,0,1,8.7,2A5.975,5.975,0,0,1,36,32.75V36Zm27,0V32.75a9.556,9.556,0,0,0-.175-1.875,7.494,7.494,0,0,0-.575-1.725,8.232,8.232,0,0,1,1.1-.125Q39.9,29,40.5,29a10.739,10.739,0,0,1,5.45,1.2A3.574,3.574,0,0,1,48,33.35V36ZM24,28.5a15.09,15.09,0,0,0-6.5,1.2Q15,30.9,15,32.75V33H33v-.3q0-1.8-2.475-3A15.057,15.057,0,0,0,24,28.5Zm-16.5-1a3.372,3.372,0,0,1-2.475-1.025,3.5,3.5,0,0,1,0-4.95A3.372,3.372,0,0,1,7.5,20.5a3.5,3.5,0,0,1,2.475,5.975A3.372,3.372,0,0,1,7.5,27.5Zm33,0a3.5,3.5,0,0,1-2.475-5.975,3.5,3.5,0,0,1,4.95,4.95A3.372,3.372,0,0,1,40.5,27.5ZM24,24a5.975,5.975,0,0,1-6-6,5.763,5.763,0,0,1,1.75-4.275A5.829,5.829,0,0,1,24,12a5.893,5.893,0,0,1,6,6,5.829,5.829,0,0,1-1.725,4.25A5.763,5.763,0,0,1,24,24Zm0-9a2.937,2.937,0,0,0-2.125.85,3.048,3.048,0,0,0,0,4.275,3.048,3.048,0,0,0,4.275,0A2.988,2.988,0,0,0,24,15Zm0,18Zm0-15Z",
    transform: "translate(0 -12)",
    fill: "#323338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternalStaffIcon);
export default __webpack_public_path__ + "static/media/internalStaff_icon.2c9bab71d124a64a6724d0b106e2ffc2.svg";
export { ForwardRef as ReactComponent };